interface ImagePreviewOptions {
  inputSelector: string;
  previewWrapperSelector: string;
  previewImgSelector: string;
  removeBtnSelector: string;
  errorSelector: string;

  maxSize?: number; // в байтах, например 2 * 1024 * 1024 (2 МБ)
}

export class ImagePreviewWidget {
  private input: HTMLInputElement;
  private wrapper: HTMLElement;
  private img: HTMLImageElement;
  private removeBtn: HTMLElement;
  private errorEl: HTMLElement;

  private maxSize: number;
  private allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

  constructor(options: ImagePreviewOptions) {
    this.input = document.querySelector(options.inputSelector)!;
    this.wrapper = document.querySelector(options.previewWrapperSelector)!;
    this.img = document.querySelector(options.previewImgSelector)!;
    this.removeBtn = document.querySelector(options.removeBtnSelector)!;
    this.errorEl = document.querySelector(options.errorSelector)!;

    this.maxSize = options.maxSize ?? 2 * 1024 * 1024; // по умолчанию 2 МБ

    this.bindEvents();
  }

  private bindEvents() {
    if (this.input && typeof this.input === 'object') {
      this.input.addEventListener('change', () => this.handleFile());
    }

    if (this.input && typeof this.input === 'object') {
      this.removeBtn?.addEventListener('click', () => this.clear());
    }
  }

  private showError(message: string) {
    this.errorEl.textContent = message;
    this.errorEl.classList.remove('d-none');
  }

  private clearError() {
    this.errorEl.textContent = '';
    this.errorEl.classList.add('d-none');
  }

  private handleFile() {
    const file = this.input.files?.[0];

    this.clearError();

    if (!file) {
      this.clear();
      return;
    }

    // Валидация типа
    if (!this.allowedTypes.includes(file.type)) {
      this.showError('Можно загружать только JPEG, PNG или WEBP файлы.');
      this.clear();
      return;
    }

    // Валидация размера
    if (file.size > this.maxSize) {
      const mb = (this.maxSize / (1024 * 1024)).toFixed(1);
      this.showError(`Файл слишком большой. Максимальный размер: ${mb} МБ.`);
      this.clear();
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.img.src = reader.result as string;
    };

    reader.readAsDataURL(file);
  }

  private clear() {
    this.input.value = '';
    this.img.src = '';
  }
}
